export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 9\"><path d=\"M4.5 8.7L.3 4.5l.7-.7 3.5 3.5 7-7 .7.7z\"/></svg>"